module.exports = __webpack_public_path__ + "img/breadcrumb.svg?d83e962c2e8b410fb4b5a81198b5c654";